import React from "react";
import { graphql } from "gatsby";
import { Cards as CardsComponent } from "@zempler/theme/src/components/cards/Cards";

export const Cards = ({ data, ...rest }) => {
  // Sort the display value

  function capitalizeUp(str: string) {
    return str?.replace(/\b(\d+)\s?up\b/gi, function (match, p1) {
      return p1.toUpperCase() + "Up";
    });
  }

  const display = capitalizeUp(data.display);

  // Sort the card items

  const cards = data.cardItems?.map((item) => {
    return {
      ...item,
      image: item.image?.image?.localFile,
      largeImage: item.largeImage?.image?.localFile,
      imagePlacement: item.imagePlacement?.toLowerCase() || "left",
    };
  });

  return <CardsComponent cards={cards} display={display || "2Up"} />;
};

export const CardsQuery = graphql`
  fragment Cards on UMBRACO_CardsComponentType {
    display
    cardItems {
      backgroundColour
      heading
      text
      imagePlacement
      link {
        ...Link
      }
      image {
        image {
          ...CardImage
        }
      }
      largeImage: image {
        image {
          ...LargeCardImage
        }
      }
    }
  }
`;
